import type { Components, Theme } from '@mui/material/styles';
import { BACKDROP_TOKENS } from '../backdrop/backdropTokens';

const { backgroundColor, backdropFilter } = BACKDROP_TOKENS.default;

export const MUI_BACKDROP_COMPONENTS: Pick<Components<Theme>, 'MuiBackdrop'> = {
  MuiBackdrop: {
    styleOverrides: {
      root: () => ({
        backgroundColor,
        backdropFilter,
        WebkitBackdropFilter: backdropFilter,
      }),
    },
  },
};
